'use strict'

import State from 'ampersand-state'
import Collection from 'ampersand-rest-collection'
import Observable from './_observable'
import {assign} from 'lodash/fp'

const MediaModel = State.extend(Observable).extend({
  props: {
    id: 'any',
    peerId: 'string',
    type: 'string',
    codec: 'string',
    track: 'object', // MediaStreamTrack
    profile: 'string',
    deviceId: 'string',
    mediaDetails: 'object',
    isRemote: 'boolean',
    supported: 'boolean',
    locallyPaused: 'boolean',
    remotelyPaused: 'boolean',
    browser: 'string',
    browserVersion: 'string',
    displayName: 'string',
    screenType: 'string',
    logger: 'object',
    consumer: 'object',
    producer: 'object',
    audioSrc: 'object',
    isMuted: ['boolean', true, false],
    level: ['number', true, 0.8],
    dependants: ['object', true, () => new Set()]
  },
  initialize (options = {}) {
    this.logger = this.logger.addNamespace('Media')
    if (!(this.peerId && this.type)) {
      throw new Error('Creating a media model requires a type and peer id')
    }

    const track$ = this.streamOfProperty('track')

    if (this.type === 'microphone' || this.type === 'audio' || this.type === 'audioFeed') {
      track$.forEach(x => {
        if (x && x.readyState !== 'ended') {
          const stream = new MediaStream([x])
          this.audioCtx = new AudioContext()
          this.audioSrc = this.audioCtx.createMediaStreamSource(stream)
        } else {
          if (this.audioCtx) {
            this.audioCtx.close()
            this.unset('audioCtx')
          }
        }
      })
    }

    track$.forEach(x => {
      if (!x) return
      x.onended = () => {
        this.logger.warn('Track readystate "ended" - closing producer for media')
        this.close()
      }
    })
  },
  replaceTrack () {

  },
  useTrack (dependantId) {
    if (!dependantId) throw new Error('Cannot call useTrack() without specifying a dependant ID')
    this.logger.info(`useTrack()`, {dependantId}, this.kind, this.label)
    this.dependants.add(dependantId)
    return this.track
  },
  stopUsingTrack (dependantId) {
    if (!dependantId) throw new Error('Cannot call stopUsingTrack() without specifying a dependant ID')
    this.logger.info(`stopUsingTrack()`, {dependantId}, this.kind, this.label)
    this.dependants.delete(dependantId)
    if (this.dependants.size === 0) {
      this.close()
    }
  },
  close () {
    try {
      if (this.producer) {
        this.producer && this.producer.close()
        this.unset('track')
      } else if (!this.isRemote) {
        if (this.track) this.track.stop()
      }
    } catch (e) {
      this.logger.warn(e)
    }
  }
})

const MediaCollection = Collection.extend({
  model: MediaModel,
  initialize () {

  }
})

export {MediaModel, MediaCollection}



// WEBPACK FOOTER //
// ./client/webrtc/greenroom-media-model.js